export default __webpack_public_path__ + "static/media/pin02@2x.b1fb3d5d.png";